import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SplitTimeInputUpdateOptions } from '@caslink/common-client';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CommandService } from '../../shared/services/command.service';
import { DeviceInputBaseComponent } from '../device-input-base.component';
import {
    CommandOptimizationRenderingService
} from '@caslink/device-client/ng-app/shared/services/command-optimization-rendering.service';

@Component({
    selector: 'dl-time-date-sensor',
    templateUrl: './time-date-sensor-input.component.html',
    styleUrls: ['./time-date-sensor-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeDateSensorInputComponent extends DeviceInputBaseComponent {
    public static $name: string = 'dateTimeSensor';

    public time: number;
    public timeFormat: string = 'HH:mm:ss';
    public timeMinValue: number = 0;
    public timeMaxValue: number = 86399; // seconds in a day - 1
    public datepickerFormControl: FormControl;

    private date: Date;

    constructor(
        private commandService: CommandService,
        protected commandOptimizationRenderingService: CommandOptimizationRenderingService,
        protected cdr: ChangeDetectorRef,
    ) {
        super(commandService, commandOptimizationRenderingService, cdr);
    }

    public ngOnInit() {
        super.ngOnInit();

        /** grab midnight of current date */
        this.date = moment(this.deviceInput.value).startOf('day').toDate();

        /** calculate number of seconds since utc midnight to get the time of day */
        // tslint:disable-next-line: max-line-length no-magic-numbers
        this.time = (moment.utc(this.deviceInput.value).toDate().getTime() - moment.utc(this.deviceInput.value).startOf('day').toDate().getTime()) / 1000;

        let validators = [
            Validators.required
        ];

        this.datepickerFormControl = this.deviceInputForm?.get(this.deviceInput.$fieldName) as FormControl || new FormControl(this.date, validators);
        this.deviceInputForm.addControl(this.deviceInput.$fieldName, this.datepickerFormControl);
    }

    public invokeCommand() {
        this.invokeChangeCommand(this.deviceInput);
    }

    public onBlur() {
        if (_.isFunction(this.deviceInput.$onBlur)) {
            this.deviceInput.$onBlur();
        }
    }

    public onTimeUpdate(event: SplitTimeInputUpdateOptions) {
        this.time = event.newValue;
        this.onUpdate();
    }

    public onDateUpdate(value) {
        if (this.datepickerFormControl.valid) {
            this.date = new Date(value);
            this.onUpdate();
        }
    }

    public onUpdate() {
        // tslint:disable-next-line: no-magic-numbers
        this.deviceInput.value = moment(this.date.getTime() + (this.time * 1000)).format('YYYY-MM-DDTHH:mm:ss') + 'Z';
        this.invokeCommand();
    }
}
